import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core"
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '../services/loader.service';
import { UserService } from '../services/user.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(
        private toast: ToastrService, private router: Router,
        private snackBar: MatSnackBar, private loaderService: LoaderService,
        private userService:UserService    
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.headers.has("skip-interceptor")) {
            const headers = request.headers.delete("skip-interceptor");
            return next.handle(request.clone({ headers }));
          }
        
        const user = JSON.parse(localStorage.getItem('user'))
        if (user) {
            const token = user.token;
            if (token) {
                request = request.clone({ 
                    headers: request.headers.set('Authorization', 'Bearer ' + token)
                                .set('platform', 'webapp')
                                .set('userAgent', navigator.userAgent)
                                .set('Monsoon-User', localStorage.getItem("monsoon_session") || '')

            });
            }
        }
        //Adding language to Request headers
        // let lang = localStorage.getItem('lang')? localStorage.getItem('lang'):'en';
        // if (lang) {
        //         request = request.clone({ headers: request.headers.set('Accept-Language', lang) });
           
        // }
        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }
        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        if (!window.navigator.onLine) {
            swal.fire("Please check your internet connection and retry!!!");
            this.loaderService.internetUpdate(window.navigator.onLine);
            return throwError(new HttpErrorResponse({ error: 'Internet is required.' }));
        }
        else {
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                    // console.log(error);
                    let errMsg = "";
                    
                    // Handle blocked/CORS/network errors (status 0)
                    if (error.status === 0) {
                        const isSigninRequest = request.url.includes('/signin') || request.url.includes('/login');
                        if (isSigninRequest) {
                            errMsg = "No Internet Connection. Please check your network settings and try again.";
                            return throwError(errMsg);
                        } else {
                            return throwError(new HttpErrorResponse({ error: 'No Internet Connection. Please check your network settings and try again.' }));
                        }
                    }
                    
                    // Handle forbidden errors (may indicate blocked requests)
                    if (error.status === 403) {
                        const isSigninRequest = request.url.includes('/signin') || request.url.includes('/login');
                        const isPinLoginRequest = request.url.includes('/pinlogin');
                        
                        // Let PIN login component handle its own errors
                        if (isPinLoginRequest) {
                            return throwError(error);
                        }
                        
                        if (isSigninRequest) {
                            errMsg = "No Internet Connection. Please check your network settings and try again.";
                            this.openSnackBar(errMsg, '');
                            return throwError(errMsg);
                        }
                    }
                    
                    if (error.status === 401) {
                        // Don't redirect to signin for PIN login API or when on pin-verification page
                        const isPinLoginRequest = request.url.includes('/pinlogin');
                        const skipAuthCheck = localStorage.getItem('skip_auth_check') === 'true';
                        const accessingFromQR = localStorage.getItem('accessing_from_qr') === 'true';
                        
                        const isOnPinVerificationPage = 
                            window.location.hash.includes('pin-verification') || 
                            window.location.href.includes('pin-verification') ||
                            this.router.url.includes('pin-verification') ||
                            skipAuthCheck ||
                            accessingFromQR;
                        
                        if (isPinLoginRequest || isOnPinVerificationPage) {
                            // Return error immediately without any localStorage clearing or navigation
                            return throwError(error);
                        }
                        
                        // For other 401 errors, proceed with normal authentication flow
                        this.userService.usersignout().then((observable) => {
                            observable.subscribe((res) => {
                                // console.log(res);
                            });
                        });
                        this.router.navigate(['authentication/signin']);
                        localStorage.clear();
                      //  console.clear();
                        // location.reload();
                        let lockedwarning = false;
                        let failedtimes;
                        let locked = false;
                        if (error.error.lockout_user) {
                            lockedwarning = true;
                            failedtimes = error.error.lockout_count - error.error.pass_fail_count;
                            if (error.error.pass_fail_count >= error.error.lockout_count) {
                                localStorage.clear();
                                locked = true;
                                lockedwarning = false;
                                // return false;
                            }
                        } else {
                            locked = false;
                        }

                        if (locked) {
                            errMsg = "locked";
                        } else {
                            errMsg = "Please enter a correct username and password.";
                            if (lockedwarning) {
                                errMsg = "Please enter a correct username and password. You have " + failedtimes + "attempts remaining.";
                            }
                        }
                    }
                    if (error.status === 409 && error.error.message == 'error') {
                        const isPinLoginRequest = request.url.includes('/pinlogin');
                        const isOnPinVerificationPage = this.router.url.includes('/pin-verification') || 
                                                       window.location.hash.includes('/pin-verification');
                        
                        // Don't redirect PIN login errors or when on pin-verification page
                        if (isPinLoginRequest || isOnPinVerificationPage) {
                            return throwError(error);
                        }

                        swal.fire("Token is Expired!");
                        this.router.navigate(['authentication/signin']);
                        localStorage.clear();
                        console.clear();
                        errMsg = "Login Token is Expired!";

                    }
                    if (error.error.errorMessage) {
                        errMsg = error.error['errorMessage'];
                    }
                    // console.log(errMsg);

                    //console.clear();
                    let errorMessage = '';
                    const isSigninRequest = request.url.includes('/signin') || request.url.includes('/login');
                    const isPinLoginRequest = request.url.includes('/pinlogin');
                    
                    // Don't show popups for PIN login errors - let the component handle them
                    if (isPinLoginRequest) {
                        return throwError(error);
                    }
                    
                    switch (error.status) {
                        case 0: {
                            // Already handled above
                            break;
                        }
                        case 201: { break; }
                        case 403: {
                            // Already handled above for signin, handle for other requests
                            if (!isSigninRequest) {
                                this.openSnackBar('Access forbidden. Please check your permissions.', '');
                            }
                            break;
                        }
                        case 404: {
                          this.openSnackBar(error?.error?.errorMessage || 'Something went wrong! try again.', '');
                          break;
                        }
                        case 500: {
                          this.openSnackBar(error?.error?.errorMessage || 'Server encountered unexpected error. Please try again later.', '');
                          break;
                        }
                        case 502: {
                            if (isSigninRequest) {
                                errMsg = "Service temporarily unavailable. The server may be under maintenance. Please try again in a few minutes.";
                                this.openSnackBar(errMsg, '');
                            } else {
                                this.openSnackBar('Bad Gateway. Please try again later.', '');
                            }
                            break;
                        }
                        case 503: {
                            if (isSigninRequest) {
                                errMsg = "Service unavailable. The server is temporarily unable to handle the request. Please try again later.";
                                this.openSnackBar(errMsg, '');
                            } else {
                                this.openSnackBar('Service unavailable. Please try again later.', '');
                            }
                            break;
                        }
                        case 504: {
                            if (isSigninRequest) {
                                errMsg = "Connection timeout. The server is taking too long to respond. Please check your internet connection and try again.";
                                this.openSnackBar(errMsg, '');
                            } else {
                                this.openSnackBar('Request timeout. Please try again.', '');
                            }
                            break;
                        }
                        case 409: {
                            // Don't show swal for PIN login - already checked above
                            swal.fire('', error.error.errorMessage, 'error');
                            break; 
                        }
                        default: { errorMessage = errMsg }
                    }
                    if (errorMessage != '') {
                        return throwError(errorMessage)
                    }
                }),
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        //console.log(event);
                    }
                    return event;
                })
            );
        }
    }

    openSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
        duration: 2000,
      });
    }
}
